import React from "react";
import { Anchor, CloudSun, Compass, Navigation, Phone, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export default function MarinaIntelligenceHero({ marina, averageRating, reviewCount, lat, lng }) {
  const available = marina.available_berths ?? "Live";
  const canNavigate = Number.isFinite(lat) && Number.isFinite(lng);

  return (
    <section className="overflow-hidden rounded-[2rem] border border-white/10 bg-slate-950 text-white shadow-2xl shadow-ocean/30">
      <div className="relative min-h-[26rem]">
        {marina.image_url ? (
          <img src={marina.image_url} alt={`${marina.name} marina`} width="1600" height="900" fetchPriority="high" className="absolute inset-0 h-full w-full object-cover" />
        ) : (
          <div className="absolute inset-0 grid place-items-center bg-gradient-to-br from-slate-950 via-cyan-950 to-blue-950"><Anchor className="h-20 w-20 text-cyan-200" /></div>
        )}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_18%,rgba(34,211,238,0.35),transparent_22rem),linear-gradient(90deg,rgba(2,6,23,0.92),rgba(2,6,23,0.52),rgba(2,6,23,0.22)),linear-gradient(0deg,rgba(2,6,23,0.98),transparent_48%)]" />

        <div className="relative z-10 flex min-h-[26rem] flex-col justify-end gap-5 p-5 sm:p-7 lg:p-8">
          <div className="max-w-4xl">
            <div className="flex flex-wrap gap-2">
              <Badge className="bg-white text-slate-950 hover:bg-white">{marina.flag} {marina.country}</Badge>
              <Badge className="border border-cyan-300/40 bg-cyan-300/15 text-cyan-50">Captain Briefing Center</Badge>
              <Badge className="border border-emerald-300/40 bg-emerald-300/15 text-emerald-50">{available} berths</Badge>
            </div>
            <h1 className="mt-4 max-w-4xl text-balance font-heading text-4xl font-black tracking-tight sm:text-5xl lg:text-6xl">{marina.name}</h1>
            <p className="mt-3 flex items-center gap-2 text-base text-cyan-50/85 md:text-lg"><Navigation className="h-5 w-5" /> {marina.location}</p>
          </div>

          <div className="grid gap-3 sm:grid-cols-3">
            <div className="rounded-3xl border border-white/10 bg-white/10 p-4 backdrop-blur-xl"><Star className="h-5 w-5 fill-amber-400 text-amber-400" /><p className="mt-2 text-2xl font-black">{averageRating ? averageRating.toFixed(1) : "—"}</p><p className="text-sm text-cyan-50/70">{reviewCount ? `${reviewCount} reviews` : "Rating pending"}</p></div>
            <div className="rounded-3xl border border-white/10 bg-white/10 p-4 backdrop-blur-xl"><CloudSun className="h-5 w-5 text-cyan-200" /><p className="mt-2 text-2xl font-black">Good</p><p className="text-sm text-cyan-50/70">Arrival window</p></div>
            <div className="rounded-3xl border border-white/10 bg-white/10 p-4 backdrop-blur-xl"><Anchor className="h-5 w-5 text-emerald-300" /><p className="mt-2 text-2xl font-black">{available}</p><p className="text-sm text-cyan-50/70">Berths</p></div>
          </div>

          <div className="flex flex-wrap gap-3 pb-1">
            {canNavigate && <Button asChild><a href={`https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`} target="_blank" rel="noopener noreferrer"><Compass className="h-4 w-4" /> Navigate</a></Button>}
            {marina.phone && <Button asChild variant="outline"><a href={`tel:${marina.phone}`}><Phone className="h-4 w-4" /> Contact Marina</a></Button>}
          </div>
        </div>
      </div>
    </section>
  );
}